import { connect } from 'react-redux';
import { getFetching } from '../../redux/Guest/selectors/file';
import { getGuestFileSearchQuery } from '../../redux/Guest/selectors/components/file-search';
import { updateGuestFileSearchQuery } from '../../redux/Guest/actions/components/file-search';
import { clearGuestFiles } from '../../redux/Guest/actions/file';
import { fetchGuestFiles } from '../../redux/Guest/sagas/routines';
import FileSearch from '../../components/guest/FileSearch';

function mapStateToProps(state, props) {
  const searchQuery = getGuestFileSearchQuery(state);
  return {
    ...props,
    query: searchQuery.q,
    queryOptions: { q: searchQuery.q },
    isFetching: getFetching(state)
  };
}

function mapDispatchToProps(dispatch, { guestId }) {
  return {
    onSubmit: queryOptions => {
      dispatch(clearGuestFiles());
      dispatch(fetchGuestFiles({ ...queryOptions, guestId }));
    },
    onChange: query => {
      dispatch(updateGuestFileSearchQuery(query));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FileSearch);
